// Stillhouse view — Billing & licensing. Plan reflects the real org; seat and
// invoice figures have no backend yet and render as empty states.
import React from "react";
import { C, Btn } from "../brand/apo";
import { Card, Chip, Toggle, PageHeader, Stat, EmptyState, COPPER } from "../brand/sh";
import { useAuth } from "../auth";

const Scroll = ({ children }: { children: React.ReactNode }) => (
  <div style={{ flex: 1, overflow: "auto", padding: "22px 32px", display: "flex", flexDirection: "column", gap: 16 }}>{children}</div>
);
function Row({ title, sub, children, last }: { title: React.ReactNode; sub?: React.ReactNode; children?: React.ReactNode; last?: boolean }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 16, padding: "15px 18px", borderBottom: last ? "none" : `1px solid ${C.line}` }}>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 14, color: C.fgDark, fontWeight: 500 }}>{title}</div>
        {sub && <div style={{ fontSize: 12.5, color: C.fgMute, marginTop: 3, lineHeight: 1.45 }}>{sub}</div>}
      </div>
      {children}
    </div>
  );
}

export function Billing() {
  const { user } = useAuth();
  return (
    <React.Fragment>
      <PageHeader
        crumb="ACCOUNT › BILLING"
        title="Billing & licensing"
        sub="One invoice for the whole organisation. Seat-based licensing with volume tiers — assign seats to members, reclaim them on deprovision."
      >
        <Btn ghost>Invoices</Btn>
        <Btn primary>Add seats</Btn>
      </PageHeader>
      <Scroll>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 14 }}>
          <Stat label="Plan" value={user?.org?.plan ?? "—"} sub="organisation tier" accent={COPPER} />
          <Stat label="Seats" value="—" sub="no seat data" accent={C.glow} />
          <Stat label="Next invoice" value="—" sub="not scheduled" accent={C.lilac} />
          <Stat label="Effective / seat" value="—" sub="no seat data" accent={C.glowDp} />
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1.3fr 1fr", gap: 16 }}>
          <Card title="Seat allocation by team" pad={false}>
            <EmptyState title="No seat allocation yet" sub="ASSIGN SEATS TO TEAMS TO SEE USAGE" />
          </Card>
          <Card title="Payment" pad={false}>
            <Row title="Method" sub="No payment method on file">
              <Chip color={C.fgMute}>None</Chip>
            </Row>
            <Row title="Billing contact" sub="Not configured">
              <Chip color={C.fgMute}>None</Chip>
            </Row>
            <Row title="Auto-renew" sub="Annual" last>
              <Toggle />
            </Row>
          </Card>
        </div>
      </Scroll>
    </React.Fragment>
  );
}
